import { Page } from './page.js'

export class Hubevents extends Page{
    ready(){

    }
}